import { Link } from "react-router-dom";
import { Mail, Phone, MapPin } from "lucide-react";

const Footer = () => {
  return (
    <footer data-testid="footer" className="bg-[#050505] border-t border-white/5 relative overflow-hidden">
      {/* Large Background Text */}
      <div className="absolute bottom-0 left-0 right-0 pointer-events-none select-none">
        <h2 className="font-heading text-[20vw] leading-none text-copper/5 text-center">
          KAIROS
        </h2>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-24">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-3 mb-6">
              <div className="w-10 h-10 relative">
                <svg viewBox="0 0 100 100" className="w-full h-full">
                  <defs>
                    <linearGradient id="copperGradientFooter" x1="0%" y1="0%" x2="100%" y2="100%">
                      <stop offset="0%" stopColor="#B87333" />
                      <stop offset="50%" stopColor="#D8AB4E" />
                      <stop offset="100%" stopColor="#8B4513" />
                    </linearGradient>
                  </defs>
                  <polygon points="50,5 95,85 5,85" fill="none" stroke="url(#copperGradientFooter)" strokeWidth="3" />
                  <polygon points="50,25 75,70 25,70" fill="none" stroke="url(#copperGradientFooter)" strokeWidth="2" />
                </svg>
              </div>
              <span className="font-heading text-xl tracking-wider copper-text">KAIROS</span>
            </div>
            <p className="text-gray-400 font-body text-sm leading-relaxed max-w-xs">
              Handcrafted copper mosaic art that transforms your favorite images into timeless masterpieces.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-heading text-lg text-white mb-6">Quick Links</h3>
            <nav className="flex flex-col gap-3">
              <Link
                to="/gallery"
                data-testid="footer-gallery-link"
                className="text-gray-400 hover:text-copper transition-colors font-body text-sm"
              >
                Gallery
              </Link>
              <Link
                to="/quote"
                data-testid="footer-quote-link"
                className="text-gray-400 hover:text-copper transition-colors font-body text-sm"
              >
                Get a Quote
              </Link>
              <Link
                to="/about"
                data-testid="footer-about-link"
                className="text-gray-400 hover:text-copper transition-colors font-body text-sm"
              >
                About
              </Link>
              <Link
                to="/contact"
                data-testid="footer-contact-link"
                className="text-gray-400 hover:text-copper transition-colors font-body text-sm"
              >
                Contact
              </Link>
            </nav>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="font-heading text-lg text-white mb-6">Get in Touch</h3>
            <div className="flex flex-col gap-4">
              <a
                href="mailto:kairoscopper@gmail.com"
                data-testid="footer-email"
                className="flex items-center gap-3 text-gray-400 hover:text-copper transition-colors font-body text-sm"
              >
                <Mail size={16} className="text-copper" />
                kairoscopper@gmail.com
              </a>
              <div className="flex items-center gap-3 text-gray-400 font-body text-sm">
                <Phone size={16} className="text-copper" />
                Contact via form
              </div>
              <div className="flex items-center gap-3 text-gray-400 font-body text-sm">
                <MapPin size={16} className="text-copper" />
                Custom Orders Worldwide
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-16 pt-8 border-t border-white/5 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-500 text-xs font-body">
            © {new Date().getFullYear()} Kairos Copper Art. All rights reserved.
          </p>
          <p className="text-gray-500 text-xs font-body">
            Handcrafted with passion
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
